import React, { useState, useEffect } from "react";
import { AuthorizedLayoutCompanies } from "../../components/AuthorizedLayoutCompanies";
import iconMoney from "../../assets/fi_10349139.png";
import iconCLose from "../../assets/Group (3).png";
import iconCheck from "../../assets/IconCheck.png";
import iconLoc from "../../assets/Vector (33).png";
import iconBack from "../../assets/Tipode material.png"
import heart from "../../assets/icon_heart_active.svg";
import heartInactive from "../../assets/icon_heart_inactive.svg";
import FitCultural from "./components/FitCultural";
import Knowledge from "./components/Knowledge";
import SelfieLetter from "./components/SelfieLetter";
import Skills from "./components/Skills";

import api from "../../utils/api";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FavoriteButton } from "../../components/FavoriteButton";

import "./DetailsTalent.css";
import LoadingIcon from "../../components/LoadingIcon";
import DetailChat from "../../components/ChatComponent/DetailChat";
import CardChat from "../../components/CardChat.js/CardChat.js";
import TalentAvatar from "../../components/TalentAvatar/TalentAvatar";
import TagLabel from "../../components/TagLabel/TagLabel";
import SharePublicProfileButton from "../../components/SharePublicProfileButton/SharePublicProfileButton";
import TalentTagsEditor from "../../components/TalentTagsEditor/TalentTagsEditor";
import { usePlanPermissions } from "../../hooks/usePlanPermissions";

const DetailsTalent = () => {
  const { id } = useParams();
  const [talents, setTalents] = useState([]);
  const [activeTab, setActiveTab] = useState("selfie");
  const [loading, setLoading] = useState(true);
  const [showLinkedInTooltip, setShowLinkedInTooltip] = useState(false);
  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const linkedInRef = React.useRef(null);
  const whatsAppRef = React.useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = usePlanPermissions();

  // Get the search params from the state that was passed
  const previousParams = location.state?.searchParams || '';
  const from = location.state?.from || "/companies/talents";
  const icon = talents?.salaryNegotiable ? iconCheck : iconCLose;
  const text = talents?.salaryNegotiable ? "Valor negociável" : "Mínimo não negociável";
  const iconSize = talents?.salaryNegotiable
    ? { width: "12px", height: "8.25px" }
    : { width: "11.29px", height: "15.06px" };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const handleLinkedInClick = (e) => {
    if (!hasPermission('see_talent_linkedin')) {
      e.preventDefault();
      if (linkedInRef.current) {
        const rect = linkedInRef.current.getBoundingClientRect();
        setTooltipPosition({
          top: rect.top - 40,
          left: rect.left + rect.width / 2
        });
      }
      setShowLinkedInTooltip(true);
      setTimeout(() => setShowLinkedInTooltip(false), 3000);
      return;
    }
  };

  const handleWhatsAppClick = (e) => {
    if (!hasPermission('see_talent_whatsapp')) {
      e.preventDefault();
      if (whatsAppRef.current) {
        const rect = whatsAppRef.current.getBoundingClientRect();
        setTooltipPosition({
          top: rect.top - 40,
          left: rect.left + rect.width / 2
        });
      }
      setShowWhatsAppTooltip(true);
      setTimeout(() => setShowWhatsAppTooltip(false), 3000);
      return;
    }
  };

  const fetcheTalent = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/companies/talents/${id}`);

      const talentData = {
        id: data?.data?.id,
        ...data?.data?.attributes,
      };

      setTalents(talentData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbBase = {
    '/companies/panel': "Página Inicial",
    '/companies/talents': "Nossa Comunidade",
  };

  useEffect(() => {
    fetcheTalent();
  }, []);

  function getFirstName(fullName) {
    return fullName?.trim()?.split(" ")[0];
  }

  const calculateAge = (birthdate) => {
    if (!birthdate) return '';
    const birthDate = new Date(birthdate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return `${age} anos`;
  };

  const handleBack = () => {
    // Navigate back with the preserved search params
    if (previousParams) {
      navigate(`${from}?${previousParams}`);
    } else {
      navigate(from);
    }
  };

  const labelWorkModel = {
    "in_person": "Presencial",
    "remote": "Home Office",
    "hybrid": "Híbrido"
  }

  const labelContractType = {
    "clt": "CLT",
    "pj": "PJ",
    "both": "CLT ou PJ"
  }

  const labelSeniorityLevel = {
    "assistant": "Auxiliar",
    "associate": "Assistente",
    "junior_analyst": "Analista Jr.",
    "analyst": "Analista Pleno",
    "senior_analyst": "Analista Sênior",
    "coordinator": "Coordenador",
    "manager": "Gerente",
    "director": "Diretor",
    "c_level": "C-Level"
  };

  return (
    <AuthorizedLayoutCompanies>
      {!loading ? (
        <>
          <div className="headerContainer">
            <div className="avatarProfile">
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <TalentAvatar
                  talent={talents}
                  width="80px"
                  height="80px"
                  background="#EC5569"
                  permitLightbox={true}
                />
                <div className="favorite-button-container">
                  <FavoriteButton
                    talent={talents}
                    heartIcon={heart}
                    heartInactiveIcon={heartInactive}
                    iconSize={{ width: "25px", height: "25px" }}
                  />
                </div>
              </div>
            </div>
            <div className="breadcrumbContainer">
              <div className="buttonBreadcrumb" onClick={handleBack}>
                <img src={iconBack} alt="" />
              </div>
              <div className="breadcrumb">{breadcrumbBase[from]} / <span className="active">Detalhes do Talento</span></div>
            </div>
          </div>
          <div className="containerBoxProfile">
            <div className="containerInfoProfile">
              <div className="containerTitleProfile">
                <div className="titleProfile">{talents?.name}</div>
                <div className="subTitleProfile">
                  <img
                    src={iconLoc}
                    alt="  "
                    style={{ width: "12.38", height: "15.75px" }}
                  />
                  <div className="textState">
                    {`${talents?.city || ""} - ${talents?.state || ""}`}
                  </div>
                  {talents?.birthdate && (
                    <>
                      <div className="separator">-</div>
                      <div className="textState">
                        {calculateAge(talents.birthdate)}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {talents?.bio && (
                <div style={{ fontSize: '14px', color: '#000', lineHeight: '1.6', marginTop: '12px', fontFamily: 'IBM Plex Sans', fontWeight: 300 }}>
                  {talents.bio}
                </div>
              )}

              {(talents?.contractType || (talents?.workModel && talents?.workModel.length > 0)) && (
                <div className="cardInfoProfile">
                  {talents?.seniorityLevel && (
                    <TagLabel text={labelSeniorityLevel[talents?.seniorityLevel]} />
                  )}

                  {talents?.contractType && (
                    <TagLabel text={labelContractType[talents?.contractType]} />
                  )}

                  {talents.workModel && talents.workModel.length > 0 && (
                    <TagLabel
                      text={talents.workModel.map((model) => labelWorkModel[model]).join(' ou ')}
                    />
                  )}
                </div>
              )}

              <div style={{ marginTop: '16px' }}>
                <TalentTagsEditor
                  talentId={id}
                  talentTags={talents.tags || []}
                  onTagsUpdate={(newTags) => {
                    if (Array.isArray(newTags)) {
                      setTalents((prev) => ({ ...prev, tags: newTags }));
                    } else {
                      fetcheTalent();
                    }
                  }}
                />
              </div>

              <div style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>
                Cadastro: {talents?.createdAt ? new Date(talents.createdAt).toLocaleString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }) : ''}<br />
                Última Atualização: {talents?.updatedAt ? new Date(talents.updatedAt).toLocaleString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }) : ''}
              </div>

              {(talents?.linkedinUrl || talents?.phone) && (
                <div style={{ marginTop: '12px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  {talents?.linkedinUrl && (
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      {hasPermission('see_talent_linkedin') ? (
                        <a
                          ref={linkedInRef}
                          href={talents.linkedinUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            color: '#0077B5',
                            textDecoration: 'none',
                            fontFamily: 'IBM Plex Sans',
                            fontSize: '13px',
                            fontWeight: 400,
                            transition: 'color 0.2s ease',
                            cursor: 'pointer'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.color = '#005885'}
                          onMouseOut={(e) => e.currentTarget.style.color = '#0077B5'}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                          </svg>
                          LinkedIn
                        </a>
                      ) : (
                        <span
                          ref={linkedInRef}
                          onClick={handleLinkedInClick}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            color: '#ABABAB',
                            textDecoration: 'none',
                            fontFamily: 'IBM Plex Sans',
                            fontSize: '13px',
                            fontWeight: 400,
                            cursor: 'not-allowed',
                            opacity: 0.6
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                          </svg>
                          LinkedIn
                        </span>
                      )}
                    </div>
                  )}

                  {talents?.phone && (
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      {hasPermission('see_talent_whatsapp') ? (
                        <a
                          ref={whatsAppRef}
                          href={`https://wa.me/${talents.phone.replace(/\D/g, '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            color: '#3BD1CA',
                            textDecoration: 'none',
                            fontFamily: 'IBM Plex Sans',
                            fontSize: '13px',
                            fontWeight: 400,
                            transition: 'color 0.2s ease',
                            cursor: 'pointer'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.color = '#0AC6BD'}
                          onMouseOut={(e) => e.currentTarget.style.color = '#3BD1CA'}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                          </svg>
                          WhatsApp
                        </a>
                      ) : (
                        <span
                          ref={whatsAppRef}
                          onClick={handleWhatsAppClick}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            color: '#ABABAB',
                            textDecoration: 'none',
                            fontFamily: 'IBM Plex Sans',
                            fontSize: '13px',
                            fontWeight: 400,
                            cursor: 'not-allowed',
                            opacity: 0.6
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                          </svg>
                          WhatsApp
                        </span>
                      )}
                    </div>
                  )}
                </div>
              )}
              <div className="cardInfoProfile">
                <div className="box1">
                  <div className="containerInfoBox">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "18px",
                        height: "18px",
                      }}
                    >
                      <img
                        src={iconMoney}
                        alt="  "
                        style={{ width: "16.13px", height: "16.13px" }}
                      />
                    </div>
                    <div className="text">{formatCurrency(talents?.salary)}</div>
                  </div>

                  <div className="containerInfoBox">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "18px",
                        height: "18px",
                      }}
                    >
                      <img src={icon} alt="" style={iconSize} />
                    </div>
                    <div className="text">{text}</div>
                  </div>
                </div>
              </div>

              {talents?.culturalFitResult?.a ? (
                <div style={{ padding: 20, boxSizing: 'border-box' }}>
                  <FitCultural culturalFitResult={talents?.culturalFitResult} />
                </div>
              ) : (
                ""
              )}
              <div style={{ marginTop: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <CardChat infoTalents={talents} />
                  <SharePublicProfileButton talent={talents} />
                </div>
              </div>
            </div>

            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={`tab-button ${activeTab === "selfie" ? "active" : ""
                    }`}
                  onClick={() => handleTabClick("selfie")}
                >
                  Selfie Letter
                </button>
                <button
                  className={`tab-button ${activeTab === "conhecimentos" ? "active" : ""
                    }`}
                  onClick={() => handleTabClick("conhecimentos")}
                >
                  Conhecimentos
                </button>
                <button
                  className={`tab-button ${activeTab === "habilidades" ? "active" : ""
                    }`}
                  onClick={() => handleTabClick("habilidades")}
                >
                  Habilidades
                </button>
              </div>
              <div className="tab-content">
                {activeTab === "conhecimentos" && (
                  <Knowledge talents={talents} />
                )}
                {activeTab === "selfie" && <SelfieLetter talents={talents} />}
                {activeTab === "habilidades" && <Skills talents={talents} />}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "150px",
            justifySelf: "center",
            marginTop: "250px",
          }}
        >
          <LoadingIcon />
        </div>
      )}

      {/* Tooltips with fixed position */}
      {showLinkedInTooltip && (
        <div style={{
          position: 'fixed',
          top: `${tooltipPosition.top}px`,
          left: `${tooltipPosition.left}px`,
          transform: 'translateX(-50%)',
          backgroundColor: '#2D2D2D',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          whiteSpace: 'nowrap',
          zIndex: 9999999,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          fontFamily: 'IBM Plex Sans',
          pointerEvents: 'none'
        }}>
          Recurso disponível no plano Lovers+
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid #2D2D2D'
          }}></div>
        </div>
      )}

      {showWhatsAppTooltip && (
        <div style={{
          position: 'fixed',
          top: `${tooltipPosition.top}px`,
          left: `${tooltipPosition.left}px`,
          transform: 'translateX(-50%)',
          backgroundColor: '#2D2D2D',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          whiteSpace: 'nowrap',
          zIndex: 9999999,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          fontFamily: 'IBM Plex Sans',
          pointerEvents: 'none'
        }}>
          Recurso disponível no plano Lovers+
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid #2D2D2D'
          }}></div>
        </div>
      )}
    </AuthorizedLayoutCompanies>
  );
};

export default DetailsTalent;
